import React from 'react';

const partnersData = [
  {
    id: 'gerresheimer',
    name: 'Gerresheimer',
    logo: '/partners/gerresheimer.svg',
    subtitle: 'Primary Packaging Glass Leader',
    alt: 'Gerresheimer Pharmaceutical Packaging'
  },
  {
    id: 'nipro',
    name: 'Nipro PharmaPackaging',
    logo: '/partners/nipro.svg',
    subtitle: 'Tubular Glass Vials & Ampoules',
    alt: 'Nipro PharmaPackaging'
  },
  {
    id: 'schott-poonawalla',
    name: 'SCHOTT Poonawalla',
    logo: '/partners/schott_poonawalla.svg',
    subtitle: 'Pharma Packaging Systems',
    alt: 'SCHOTT Poonawalla Pharma Packaging'
  },
  {
    id: 'borosil',
    name: 'Borosil Scientific',
    logo: '/partners/borosil_scientific.svg',
    subtitle: 'Specialty Laboratory Glassware',
    alt: 'Borosil Scientific Glassware'
  },
  {
    id: 'khemka',
    name: 'Khemka Group',
    logo: '/partners/khemka_group.svg',
    subtitle: 'Neutral Glass Ampoules & Vials',
    alt: 'Khemka Group USGU Glass Packaging'
  },
  {
    id: 'glassco',
    name: 'Glassco Group',
    logo: '/partners/glassco.png',
    subtitle: 'Precision Laboratory Glassware',
    alt: 'Glassco Laboratory Glassware'
  }
];

const Partners = () => {
  return (
    <section id="partners" className="partners-section py-4 py-lg-5 bg-light border-bottom position-relative">
      <div className="container">
        {/* Section Header */}
        <div className="text-center max-w-700 mx-auto mb-4 mb-lg-5 px-2">
          <div className="d-inline-flex align-items-center gap-2 px-3 py-1 rounded-pill bg-white border text-primary small fw-semibold mb-2 shadow-2xs">
            <i className="fas fa-handshake text-primary"></i>
            <span>Trusted Industrial Clients</span>
          </div>
          <h2 className="fw-bold text-dark fs-4 fs-sm-3 mb-2" style={{ maxWidth: '580px', margin: '0 auto', lineHeight: '1.25' }}>
            Serving India’s &amp; Global Pharmaceutical Packaging Leaders
          </h2>
          <p className="text-muted small mb-0 px-1" style={{ maxWidth: '640px', margin: '0 auto', lineHeight: '1.55', fontSize: '0.86rem' }}>
            We engineer high-precision replacement burners, chuck spares, drive shafts, and custom tooling operating in prominent pharmaceutical and tubular glass manufacturing facilities.
          </p>
        </div>

        {/* Partners Logo Grid - 6 columns on desktop, 3 on tablet, 2 on mobile */}
        <div className="row g-2.5 g-sm-3 g-lg-3 justify-content-center align-items-stretch">
          {partnersData.map((partner) => (
            <div key={partner.id} className="col-6 col-sm-4 col-lg-2">
              <div className="partner-card bg-white p-3 rounded-3 border h-100 d-flex flex-column align-items-center justify-content-between text-center shadow-2xs transition-all">
                <div className="partner-logo-box d-flex align-items-center justify-content-center w-100 py-2" style={{ minHeight: '60px' }}>
                  <img
                    src={partner.logo}
                    alt={partner.alt}
                    className="img-fluid object-fit-contain"
                    style={{ maxHeight: '44px', maxWidth: '90%', filter: 'contrast(1.05)' }}
                  />
                </div>
                <div className="border-top pt-2 mt-1 w-100">
                  <div className="partner-name fw-bold text-dark lh-sm" style={{ fontSize: '0.82rem' }}>
                    {partner.name}
                  </div>
                  <div className="partner-subtitle text-muted mt-0.5 text-truncate" style={{ fontSize: '0.67rem', lineHeight: '1.2' }}>
                    {partner.subtitle}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom Trust Highlight */}
        <div className="text-center mt-3 mt-lg-4 px-2">
          <span
            className="badge bg-white text-secondary border px-3 py-2 rounded-pill shadow-2xs small fw-medium text-wrap"
            style={{ maxWidth: '96%', whiteSpace: 'normal', lineHeight: '1.4', display: 'inline-block' }}
          >
            <i className="fas fa-check-circle text-success me-1.5"></i>
            Precision Tooling &amp; Emergency Repair Support for Over 25+ Packaging Plants
          </span>
        </div>
      </div>
    </section>
  );
};

export default Partners;
